import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import App from "./components/App";
import store from "./store";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./styles/App.sass";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </Provider>
);
serviceWorkerRegistration.register();
